// @flow

import {isMarkdocAstTag, Tag} from 'docs/util';

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const PaymentsMoreGuides: MarkdocTagRegistration = {
  tag: 'payments-more-guides',
  component: 'PaymentsMoreGuides',
};

export const PaymentsMoreGuidesCategory: MarkdocTagRegistration = {
  tag: 'payments-more-guides-category',
  component: 'PaymentsMoreGuidesCategory',
  attributes: {
    title: {
      type: String,
      required: true,
      description: 'Description of category mapping',
      localizable: true,
    },
  },
  validate(node) {
    if (node.children.length !== 1 || node.children[0].type !== 'list') {
      return [
        {
          id: 'payments-more-guides-category',
          level: 'critical',
          message:
            'payments-more-guides-category must have one children that is a list',
        },
      ];
    }
    return [];
  },
  render(node, config) {
    const attributes = node.renderAttributes(this.attributes, config);
    const children = node.renderChildren(config);
    if (isMarkdocAstTag(children[0])) {
      // From validator we know the first child must be a list element, we do the
      // if check to inform flow.
      children[0].attributes.type = 'list-style-none';
    }
    return new Tag(this.tag, attributes, children);
  },
};
